import request from '@/utils/request'

/**
 * @description 通用Get接口
 * @param url
 * @param params
 * @returns {AxiosPromise}
 * @constructor
 */
export function GetRequest (url, params) {
  return request({
    url: url,
    method: 'get',
    params
  })
}
